var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormFileUpload" } }, [
    _c("div", { class: "form-file-upload  file-upload-align-" + _vm.align }, [
      _c("h3", [_vm._v(_vm._s(_vm.fieldLabelFile))]),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "100%" } }, [
        _c("div", { staticClass: "upload-container" }, [
          _c(
            "label",
            { staticClass: "file-label", attrs: { for: "file-upload" } },
            [
              _c("md-icon", { staticClass: "upload-icon" }, [
                _vm._v("cloud_upload"),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.altLabelOne))]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("label", [_vm._v(_vm._s(_vm.altLabelTwo))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }